var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',{attrs:{"sm":"10"}},[_c('b-row',{staticClass:"justify-content-center text-center py-4"},[_c('b-skeleton-table',{attrs:{"rows":5,"columns":7,"table-props":{ bordered: true, striped: true }}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }